<template>
  <div>
    <div>
      DASH alert status indicators and their descriptions:
    </div>
    <div class="description-container">
      <div class="description">
        <div class="indicator prefix-icon green-dot">Clean</div>
        <div class="desc-text">The alert has never been triggered.</div>
      </div>
      <div class="description">
        <div class="indicator prefix-icon red-dot">Firing</div>
        <div class="desc-text">The alert has been triggered.</div>
      </div>
      <div class="description">
        <div class="indicator prefix-icon red-circle">Fired</div>
        <div class="desc-text">
          The alert has previously been triggered but has since been resolved.
        </div>
      </div>
      <div class="description">
        <div class="indicator prefix-icon yellow-dot">Snoozed</div>
        <div class="desc-text">
          Notifications for the alert have been disabled.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertStatusIndicators'
};
</script>

<style lang="scss" scoped>
.description-container {
  margin: 1rem 0;
  margin-left: 1rem;

  .description {
    margin: 0.5rem 0;
    display: flex;
    flex-direction: row;

    .indicator {
      width: 6.5rem;
    }

    .desc-text {
      margin-left: 0;
    }
  }
}

.mobile {
  .description-container {
    margin-left: 0;
    .description {
      flex-direction: column;

      .desc-text {
        margin-left: 1.2rem;
      }
    }
  }
}
</style>
